import { Check, ArrowLeft } from 'lucide-react';
import { WorkflowStep } from '@/types';
import { Button } from "@/components/ui/button";

interface StepIndicatorProps {
  currentStep: WorkflowStep;
  onBack?: () => void;
}

const steps: { id: WorkflowStep; label: string }[] = [
  { id: 'setup', label: 'Projekt Setup' },
  { id: 'upload', label: 'Fotos & Räume' },
  { id: 'review', label: 'Generieren & Bearbeiten' },
  { id: 'upscale', label: 'Upscaling' },
  { id: 'branding', label: 'Branding & Export' },
];

export const StepIndicator: React.FC<StepIndicatorProps> = ({ currentStep, onBack }) => {
  const currentIndex = steps.findIndex((s) => s.id === currentStep);

  return (
    <div className="w-full py-4">
      <div className="flex items-center justify-between">
        {/* Back Button (only on mobile when applicable) */}
        <div className="w-10 md:hidden">
          {onBack && currentIndex > 0 && (
            <Button
              variant="ghost"
              size="icon"
              onClick={onBack}
              className="text-muted-foreground"
            >
              <ArrowLeft className="w-5 h-5" />
            </Button>
          )}
        </div>

        {/* Step Indicators */}
        <div className="flex items-center justify-center flex-1">
          {steps.map((step, index) => {
            const isCompleted = index < currentIndex;
            const isCurrent = step.id === currentStep;

            return (
              <div key={step.id} className="flex items-center">
                {index > 0 && (
                  <div
                    className={`w-6 md:w-10 h-1 mx-1 md:mx-2 rounded transition-colors duration-300 ${
                      isCompleted || isCurrent ? 'bg-primary' : 'bg-muted'
                    }`}
                  />
                )}
                <div className="flex flex-col items-center">
                  <div
                    className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold transition-colors duration-300
                      ${
                        isCompleted
                          ? 'bg-primary text-primary-foreground'
                          : isCurrent
                            ? 'bg-primary text-primary-foreground'
                            : 'bg-muted text-muted-foreground'
                      }
                    `}
                  >
                    {isCompleted ? <Check className="w-4 h-4" /> : index + 1}
                  </div>
                  <span
                    className={`text-xs mt-1 font-medium whitespace-nowrap hidden md:block ${
                      isCurrent ? 'text-primary' : 'text-muted-foreground'
                    }`}
                  >
                    {step.label}
                  </span>
                </div>
              </div>
            );
          })}
        </div>

        {/* Spacer for alignment */}
        <div className="w-10 md:hidden" />
      </div>

      {/* Mobile: Current Step Label */}
      <div className="md:hidden text-center mt-2">
        <span className="text-sm font-medium text-primary">
          {steps[currentIndex]?.label}
        </span>
      </div>
    </div>
  );
};
